import { z } from 'zod';
// mag-campaign-closer output — spec §0b.3. When a campaign reaches
// its target_close_date (or the founder closes it manually), the
// closer agent reads the campaign's full arc (deliverables, slots,
// metrics, mag's prior theses, founder taps) and writes a 2-3
// sentence closing read + a verdict.
//
// The closing_read lands on the campaign row + flows into:
//   - the next memo's "what i shipped" receipts
//   - brand-brain episodic memory (so the next time a similar push
//     comes up, mag carries the prior lesson)
//   - the campaign's permanent detail page
export const magCampaignCloserVerdictSchema = z.enum(['success', 'failure', 'inconclusive']);
export const magCampaignCloserOutputSchema = z.object({
    /** Mag's read on whether the campaign hit its goal. Drives the
     *  memo's framing + whether the trust ledger offers a
     *  drop_clearance card. */
    verdict: magCampaignCloserVerdictSchema,
    /** 2-3 sentence closing read. Lowercase, mag voice. Names what
     *  shipped, cites the signal, ends with a forward-looking note
     *  (what mag would do next time / what this teaches us). */
    closingRead: z.string().min(40).max(800),
    /** Optional brand-brain hint mag would write back if this verdict
     *  carries a durable lesson. Free-form mag-voice; the brain-coach
     *  picks it up on its next weekly run. */
    brainHint: z.string().min(1).max(280).optional(),
});
//# sourceMappingURL=mag-campaign-closer.js.map